export const SET_LOADING = 'SET_LOADING';
export const SET_PAGE = 'SET_PAGE';
export const LOGGED_IN = 'LOGGED_IN';
export const SET_BACKDROP = 'SET_BACKDROP';
export const SET_PASSWORD_MODAL = 'SET_PASSWORD_MODAL';
export const RESET = 'RESET';
